import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { StatusService } from "app/services/status.service";
import {
  AdminAnnualComplianceListFilterConfig,
  MonthlyComplianceFilterConfig,
  AdminMonthlyComplianceListFilterConfig,
  AnnualComplianceFilterConfig,
  ConsultantFormConfig,
  DepotListFilterConfig,
  DummyFormConfig,
  ExtenalCarrierConfig,
  ExternalRouteListFormConfig,
  InternalRouteListFormConfig,
  PermitFormConfig,
  PermitTypeFormConfig,
  VehicleFormConfig,
  EnquireConfig, PermitSearchConfig,
  CorspdcFormConfig,
  WFInboxFilterConfig,
  WFManageFilterConfig
} from './filter.constant';
import { FilterType } from "./filter.interface";
import { FilterService } from "./filter.service";
import { CountryService } from "../../services/country.service";
import { VehicleTypeService } from "../../services/vehicle-type.service";
import { PermitTypeService } from "app/services/permit-type.service";
import { DatePipe } from "@angular/common";
import { WorkflowService } from "app/services/workflow.service";
@Component({
  selector: "app-filter",
  templateUrl: "./filter.component.html",
  styleUrls: ["./filter.component.scss"],
})
export class FilterComponent {
  activeIndex: number = 0;
  statuses: any;
  // This will be passed to the component selector
  @Input() formConfig = DummyFormConfig;
  @Input() showVehicleFilter: boolean = false;
  filterForm: FormGroup;
  minDate = new Date();
  @Output() formValueChanged = new EventEmitter();
  selectedIndex: number;
  @Input() carrierName;
  @Input() carrierNumber;
  @Input() selectedItems;
  @Input() code;
  @Input() description;
  @Input() appFees;
  @Input() permitFees;
  premitStatuses: any;
  provinceList: any = [];
  vehicleTypes: any = [];
  filterCriteria: any;
  searchResults: any[];
  permits: any = [];
  @ViewChildren("checkboxes") checkboxes: QueryList<ElementRef>;
  constructor(
    private statusService: StatusService,
    private filterCarrier: FilterService,
    private router: Router,
    private countryService: CountryService,
    private vehicleTypeService: VehicleTypeService,
    private permitTypService: PermitTypeService,
    private datePipe: DatePipe,
    private workflowservice: WorkflowService
  ) {
    if (this.router.url.indexOf("/permit/approval") !== -1) {
      this.formConfig = PermitFormConfig; // based on the url route
      this.filterForm = this.buildForm(this.formConfig);
      this.loadPermitStatuses(); // based on the url route
    }
    if (this.router.url.indexOf("/account/approval") !== -1) {
      this.filterForm = this.buildForm(this.formConfig);
      this.loadStatuse(); // this based on the url of the screen
    }

    if (this.router.url.indexOf("/carrier/consultant") !== -1) {
      this.formConfig = ConsultantFormConfig;
      this.filterForm = this.buildForm(this.formConfig);
      this.loadConsultantsData(); // this based on the url of the screen
    }

    if (this.router.url.indexOf("/carrier/permit/application/") !== -1 && this.router.url.indexOf("mypermits") === -1) {
      this.formConfig = ExternalRouteListFormConfig;
      this.filterForm = this.buildForm(this.formConfig);
      this.loadexternalRoutesConfings();
    }
    if (this.router.url.indexOf("/route/management/list") !== -1) {
      this.formConfig = InternalRouteListFormConfig;
      this.filterForm = this.buildForm(this.formConfig);
      this.loadexternalRoutesConfings();
      this.resetFilter();
    }
    if (this.router.url.indexOf("permit/type/list") !== -1) {
      this.formConfig = PermitTypeFormConfig;
      this.filterForm = this.buildForm(this.formConfig);
    } //carrier/accounts
    if (this.router.url.indexOf("carrier/accounts") !== -1) {
      this.formConfig = ExtenalCarrierConfig;
      this.filterForm = this.buildForm(this.formConfig);
      this.loadExternalStatus();
    }
    if(this.router.url.indexOf("permit/type/list")!== -1){
      this.formConfig = ExtenalCarrierConfig;
      this.filterForm = this.buildForm(this.formConfig);
    }
    if (
      this.router.url.indexOf("permit/my-vehicles") !== -1 ||
      this.showVehicleFilter
    ) {
      this.formConfig = VehicleFormConfig;
      this.filterForm = this.buildForm(this.formConfig);
      this.loadVehiclesData();
      //this.resetFilter();
    }

    if (this.router.url.indexOf("carrier-depot/list") !== -1) {
      this.formConfig = DepotListFilterConfig;
      this.filterForm = this.buildForm(this.formConfig);
    }
    if (this.router.url.indexOf("monthly-compliance/list") !== -1) {
      this.formConfig = MonthlyComplianceFilterConfig;
      this.filterForm = this.buildForm(this.formConfig);
     // this.resetFilter();
    }
    if (this.router.url.indexOf("admin/monthly-compliance") !== -1) {
      this.formConfig = AdminMonthlyComplianceListFilterConfig;
      this.filterForm = this.buildForm(this.formConfig);
     // this.resetFilter();
    }
    if (this.router.url.indexOf("admin-annual-compliance/list") !== -1) {
      this.formConfig = AdminAnnualComplianceListFilterConfig;
      this.filterForm = this.buildForm(this.formConfig);
      this.loadexternalRoutesConfings();
      this.resetFilter();
      return;
    }
    if (this.router.url.indexOf("permit/history") !== -1 || this.router.url.indexOf("mypermits")!== -1) {
      this.formConfig = PermitSearchConfig;
      this.filterForm = this.buildForm(this.formConfig);
      this.loadPermitSearchConfigs();
    }
    if (this.router.url.indexOf("maintain-view-permit") !== -1) {
      this.formConfig = EnquireConfig;
      this.filterForm = this.buildForm(this.formConfig);
      this.resetFilter();
      this.getPermitTypes();
       this.getStatus();
      
      //this.setDefaultDate();
      
    }
    if (this.router.url.indexOf("corspdc/list") !== -1){
      this.formConfig = CorspdcFormConfig;
      this.filterForm = this.buildForm(this.formConfig);

    }

    if (this.router.url.indexOf("workflow/myinbox") !== -1) {
      this.formConfig = WFInboxFilterConfig;
      this.filterForm = this.buildForm(this.formConfig);
      this.loadexternalRoutesConfings();
      this.resetFilter();
      return;
    }

    if (this.router.url.indexOf("workflow/manage") !== -1) {
      this.formConfig = WFManageFilterConfig;
      this.filterForm = this.buildForm(this.formConfig);
      this.loadexternalRoutesConfings();
      this.resetFilter();
      return;
    }
  }

  loadexternalRoutesConfings() {
    //CHECKBOXES

    //worflow - constant dropdown
    let apptypes: any = [
      { apptypesid: "Carrier Application", desc: "Carrier Application" },
      { apptypesid: "Permit Application", desc: "Permit Application" },
      { apptypesid: "Annual Compliance", desc: "Annual Compliance" },
    ];

    //DROPDOWNS
    let dropdowns = this.formConfig.filter(
      (control) => control.inputType === "dropdownIds"
    );

    dropdowns.forEach((dropdown) => {
      if (dropdown.controlName == "provinceName") {
        //TO DO FILTER PROVINCES FROM ZA
        this.countryService
          .listAllProvincesByCountryId(113)
          .subscribe((res) => {
            this.provinceList = res;
            dropdown.dropdownOptions = this.provinceList.map((province) => ({
              id: province.id,
              desc: province.description,
            }));
          });
      } else if (dropdown.controlName == "PermitType") {
        //TO DO GET THE CASCADED DROPDOW
        this.permits = [];
        this.permitTypService.getAll().subscribe((res) => {
          this.permits = res;

          dropdown.dropdownOptions = this.permits.map((res) => ({
            id: res.id,
            desc: res.description,
          }));
        });
      } else if (dropdown.controlName == "destinationCountry") {
        //TO DO GET THE CASCADED DROPDOW
        this.countryService.listAllCountries().subscribe((res) => {
          let countries: any = [];
          countries = res;
          dropdown.dropdownOptions = countries.map((country) => ({
            id: country.id,
            desc: country.desc,
          }));
        });
      } else if (dropdown.controlName == "WFAppType") {
        this.workflowservice.getWorkflowRouteType().subscribe((res) => {
          let routestypes: any = [];
          routestypes = res;
          dropdown.dropdownOptions = routestypes.map((routestype) => ({
            id: routestype.id,
            desc: routestype.name,
          }));
        });
      } else if (dropdown.controlName == "WFRouteType") {
        dropdown.dropdownOptions = apptypes.map((apptypes) => ({
          id: apptypes.apptypesid,
          desc: apptypes.desc,
        }));
      }
    });
  }

  loadConsultantsData() {
    let roles: any = [
      { role: 1, desc: "Lead User" },
      { role: 2, desc: "Editor User" },
      { role: 6, desc: "Read User" },
      { role: 11, desc: "Owner" },
      { role: 12, desc: "Consultant" },
      { role: 21, desc: "Main Contact" },
    ];

    let statuses: any = [
      { statusid: 1, desc: "Active" },
      { statusid: 2, desc: "Inactive" },
    ];

   

    let checkboxes = this.formConfig.filter(
      (control) => control.inputType === "checkbox"
    );

    checkboxes.forEach((checkbox) => {
      if (checkbox.title == "Role") {
        checkbox.checkboxOptions = roles.map((role) => ({
          id: role.id,
          desc: role.desc,
        }));
      } else {
        checkbox.checkboxOptions = statuses.map((status) => ({
          id: status.statusid,
          desc: status.desc,
        }));
      }
    });
  }

  loadVehiclesData() {
    //DROPDOWNS
    let dropdowns = this.formConfig.filter(
      (control) => control.inputType === "dropdownIds"
    );

    dropdowns.forEach((dropdown) => {
      if (dropdown.controlName == "vehicleType") {
        this.vehicleTypeService.loadvehicletypes().subscribe((result) => {
          this.vehicleTypes = result;
          dropdown.dropdownOptions = this.vehicleTypes.map((vehicleType) => ({
            id: vehicleType.id,
            desc: vehicleType.description,
          }));
        });
      }
    });
  }

  loadStatuse() {
    if (this.formConfig.find((x) => x.inputType == "checkbox")) {
      this.formConfig.find((x) => x.inputType == "checkbox").checkboxOptions =
        [];
    }

    this.statusService.statusesDDL().subscribe((result: any) => {
      this.statuses = result.map((row) => {
        this.formConfig
          .find((x) => x.inputType == "checkbox")
          .checkboxOptions.push(row);
        return { id: row.id, desc: row.desc };
      });

      this.statuses = [];
    });
  }

  loadPermitSearchConfigs(){
    this.formConfig.find((x) => x.inputType == "checkbox").checkboxOptions = [];
    this.statusService.statusesDDL(2).subscribe((result: any) => {
      let activeStatuses: any = result.filter((x) => x.is_active == true && (x.id > 74 || x.id == 51));
      console.log("Active Status", activeStatuses);
    this.premitStatuses = activeStatuses.map((row) => {
        this.formConfig
            .find((x) => x.inputType == "checkbox")
            .checkboxOptions.push(row);
        return { id: row.id, desc: row.desc };
      });

      this.premitStatuses.sort((a, b) =>
          a.sort_order > b.sort_order ? 1 : -1 && a.desc > b.desc ? 1 : -1
      );
    });
  }

  loadExternalStatus() {
    if (this.formConfig.find((x) => x.inputType == "checkbox")) {
      this.formConfig.find((x) => x.inputType == "checkbox").checkboxOptions =
        [];
    }
    this.statusService.statusesDDL().subscribe((result: any) => {
      this.statuses = result.map((row) => {
        this.formConfig
          .find((x) => x.inputType == "checkbox")
          .checkboxOptions.push(row);
        return { id: row.id, desc: row.desc };
      });

      this.statuses = [];
    });
  }

  loadPermitStatuses() {
    this.formConfig.find((x) => x.inputType == "checkbox").checkboxOptions = [];
    this.statusService.statusesDDL(2).subscribe((result: any) => {
      let activeStatuses: any = result.filter((x) => x.is_active == true);
      this.premitStatuses = activeStatuses.map((row) => {
        this.formConfig
          .find((x) => x.inputType == "checkbox")
          .checkboxOptions.push(row);
        return { id: row.id, desc: row.desc };
      });

      this.premitStatuses.sort((a, b) =>
        a.sort_order > b.sort_order ? 1 : -1 && a.desc > b.desc ? 1 : -1
      );
    });
  }

  getStatus(){
    if (this.formConfig.find((x) => x.inputType == "checkbox")) {
      this.formConfig.find((x) => x.inputType == "checkbox").checkboxOptions = [];
    }

      this.statusService.statusesDDL().subscribe((result: any) => {
        
      this.statuses = result.map((row) => {
        this.formConfig
          .find((x) => x.inputType == "checkbox")
          .checkboxOptions.push(row);
        return { id: row.id, desc: row.desc };
      });

      this.statuses = [];
    });
  }
  getPermitTypes(){
    //DROPDOWNS
    let dropdowns = this.formConfig.filter(
      (control) => control.inputType === "dropdownIds"
    );

    dropdowns.forEach((dropdown) => {
      if (dropdown.controlName == "permit_type") {
        this.permitTypService.getAll().subscribe((result) => {
          this.permits = result;
          dropdown.dropdownOptions = this.permits.map((permit) => ({
            id: permit.id,
            desc: permit.description,
          }));
        });
      }
    });
  }

  setDefaultDate() {
    const thirtyDaysAgo = this.getDateDaysAgo(91);
    
    this.formConfig.forEach((control) => {
      if (control.inputType === "date") {
        const controlName = control.controlName;
        const formControl = this.filterForm.controls[controlName];
        
        if (formControl) {
          if (controlName === "dateFrom") {
            formControl.setValue(thirtyDaysAgo);
          } else if (controlName === "dateTo") {
            formControl.setValue(this.datePipe.transform(
              this.minDate.setDate(this.minDate.getDate() + 1),
              'dd/MM/yyyy'
          ));
           
          }
        }
      }
    });
  }
  
  getDateDaysAgo(daysAgo: any) {
    const date = new Date();
    date.setDate(date.getDate() - daysAgo);
    return this.datePipe.transform(date,'dd/MM/yyyy');
  }
  

  /**
   *@description Will create and return a form group according to the config passed
   * @param controlsData
   * @returns Form group according to the config passed
   */
  buildForm(config: Array<FilterType>) {
    const group: any = {};
    config.forEach((control: FilterType) => {
      if (
        control.inputType === "rangeDate" &&
        control.startControlName &&
        control.endControlName
      ) {
        group[control.startControlName] = new FormControl(null);
        group[control.endControlName] = new FormControl(null);
      } else {
        group[control.controlName as string] = new FormControl(null);
      }
    });
    return new FormGroup(group);
  }

  /**
   * @description Returns Form Filter controls
   */
  get f() {
    return this.filterForm.controls;
  }

  /**
   *
   * @description Store value of all the check boxes in form control
   */
  onCheckboxChange(event: any, option: string, formControlName: string) {
    this.filterForm.markAsDirty();
    let checkItem: Array<string> = this.filterForm.get(formControlName)?.value
      ? [...this.filterForm.get(formControlName)?.value]
      : [];

    if (event.target.checked) {
      checkItem.push(option);
    } else {
      let idx = checkItem.findIndex((item) => item == option);
      checkItem.splice(idx, 1);
    }
    this.filterForm?.get(formControlName).setValue(checkItem);
  }

  /**
   *
   * @description Emits form value
   */
  submitForm() {
    this.formValueChanged.emit(this.filterForm.value);
    this.filterCarrier.setData(this.filterForm.value);
    this.filterCriteria = this.filterCarrier.getFilterCriteria();
    this.filterCarrier.getSearchResults().subscribe((results) => {
      this.searchResults = results;
    });

    if (this.router.url.indexOf("/permit/approval") !== -1) {
      document.getElementById("onSearchPermit").click();
    }
    if (this.router.url.indexOf("/account/approval") !== -1) {
      document.getElementById("onSearchAccount").click();
    }
    if (this.router.url.indexOf("/carrier/consultant") !== -1) {
      document.getElementById("btnSearch").click();
    }
    if (this.router.url.indexOf("/carrier/permit/application/") !== -1 && this.router.url.indexOf("mypermits") === -1) {
      document.getElementById("btnSearch")?.click();
    }
    if (this.router.url.indexOf("/route/management/list") !== -1) {
      document.getElementById("btnSearch").click();
    }
    if (this.router.url.indexOf("/permit/my-vehicles") !== -1) {
      document.getElementById("btnSearch").click();
    }
    if (this.router.url.indexOf("/admin/monthly-compliance") !== -1) {
      document.getElementById("btnSearch").click();
    }


    if (this.router.url.indexOf("permit/history") !== -1 || this.router.url.indexOf("mypermits")!== -1) {
      document.getElementById("btnPermitSearch")?.click();
    }

    if (this.router.url.indexOf("/carrier/permit/application/") !== -1 && this.router.url.indexOf("mypermits") === -1) {
      document.getElementById("btnSearch")?.click();
    }
    if (this.router.url.indexOf("/route/management/list") !== -1) {
      document.getElementById("btnSearch").click();
    }
    if (this.router.url.indexOf("maintain-view-permit") !== -1) {
      document.getElementById("btnSearch").click();
    }
    if (this.router.url.indexOf("monthy-compliance/list") !== -1) {
      document.getElementById("btnSearch").click();
    }
    // if (this.router.url.indexOf("/admin-annual-compliance/list") !== -1) {
    //   document.getElementById("btnSearch").click();
    // }
    if (this.router.url.indexOf("corspdc/list") !== -1) {
      console.log("Apply button event");
      document.getElementById("btnSearch").click();
    }
  }

  resetFilter() {
    if (this.filterForm.controls && this.filterForm.controls.Statuses) {
      this.filterForm.controls.Statuses.reset();
    }
    const controls = this.filterForm.controls;
    for (const key in controls) {
      const control = this.filterForm.get(key);
      control.reset();
    }
    this.filterForm.reset();
    if (this.checkboxes && this.checkboxes.length) {
      this.checkboxes.forEach((element) => {
        element.nativeElement.checked = false;
      });
    }
    this.formValueChanged.emit(null);
    if (this.router.url.indexOf("/carrier/accounts") !== -1) {
      document.getElementById("resetCarrierFilter").click();
    }
    if (this.router.url.indexOf("/monthly-compliance/list") !== -1) {
      document.getElementById("resetMonthlyComplianceFilter").click();
    }
    if (this.router.url.indexOf("/account/approval") !== -1) {
      document.getElementById("onResetAccount").click();
    } //
    if (this.router.url.indexOf("/permit/approval") !== -1) {
      document.getElementById("onResetPermit").click();
    }

    if (
      this.router.url.indexOf("permit/my-vehicles") !== -1 ||
      this.showVehicleFilter
    ) {
      //console.log(' what is showVehicleFilter ' + this.showVehicleFilter);
      this.filterCarrier.setData(null);
      this.formConfig = VehicleFormConfig;
      this.filterForm = this.buildForm(this.formConfig);
      
      document.getElementById("btnReset").click();
    }

    if (this.router.url.indexOf("permit/history") !== -1 || this.router.url.indexOf("mypermits")!== -1) {
      if( document.getElementById("btnResetFilter"))
       document.getElementById("btnPermitResetFilter")?.click();
    }

    if (this.router.url.indexOf("corspdc/list") !== -1) {
      document.getElementById("btnReset").click();
    }
  }

  // ngOnInit(): void {
  //     this.filterCriteria = this.filterCarrier.getFilterCriteria();
  //     this.filterCarrier.getSearchResults().subscribe(results => {
  //       this.searchResults = results;
  //     });
  //   }
}
